<template>
  <div class="archive">
    <el-card shadow="never">
      <el-form :inline="true" ref="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.projectName" @input="querySearchAsync" :placeholder="$t('projectNameTip')" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.controllerPsn" :placeholder="$t('psnCode')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-show='!$store.state.debugFlag' @click="handleRows" :loading="quering">{{
              $t('queryButton')
            }}
          </el-button>
          <el-button type="primary" @click="handleSave" v-show='$store.state.debugFlag' :loading="searching">{{
              $t('saveButton')
            }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div v-show='$store.state.debugFlag' class='version'>{{$t('panelVersion')}}:
      <span v-show="!!settingList">{{!!settingList && settingList.version}}</span>
    </div>
    <div class='search-drop' v-show="isShow">
      <ul v-show="!loading" class="loaded">
        <li v-for="(item,index) in projectList" :key="index" @click="handleSelect(item)">
          {{ item.projectName }}
        </li>
      </ul>
      <ul v-show="loading" class="is-loading">
        <li>
          <i class="el-icon-loading"></i>
        </li>
      </ul>
    </div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>{{ $t('systemSetting') }}</span>
      </div>
      <div class="settingContent">
        <span class="text item">
          {{ $t('loopboard') }}
        </span>
        <span class="text item">
          {{ $t('multiline') }}
        </span>
        <span class="text item">
          {{ $t('busline') }}
        </span>
         <span class="text item">
          {{ $t('gasExtinguishing') }}
        </span>
        <span class="text item">
          {{ $t('broadcast') }}
        </span>
         <span class="text item">
          {{ $t('eventRecord') }}
        </span>
         <span class="text item">
          {{ $t('crt') }}
        </span>
         <span class="text item">
          {{ $t('gateway') }}
        </span>
        <span class="text item">
          {{ $t('gprs') }}
        </span>
        <span class="text item">
          {{ $t('wifi') }}
        </span>
        <span class="text item">
          {{ $t('serial') }}
        </span>
        <span class="text item">
          {{ $t('interfaceCard') }}
        </span>
      </div>
      <div class="settingContent" v-show="settingList">
        <span class="text item">
          {{ !!settingList && settingList.loopboard }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.multiline }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.busline }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.gasExtinguishing }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.broadcast }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.eventRecord }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.crt }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.gateway }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.gprs }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.wifi }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.serial }}
        </span>
        <span class="text item">
          {{ !!settingList && settingList.interfaceCard }}
        </span>
      </div>
      <div class="nodata" v-show="!settingList">{{$t('nodata')}}</div>
    </el-card>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t('boardInformation') }}</span>
          </div>
          <el-table ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching"
                    class="rows-list">
            <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
            <el-table-column prop="boardType" :label="$t('boardType')" width="80px" :show-overflow-tooltip='true'
                             align="center"></el-table-column>
            <el-table-column prop="boardNo" :label="$t('boardNumber')" width="80px" :show-overflow-tooltip='true'
                             align="center"></el-table-column>
            <el-table-column prop="boardPsn" :label="$t('psn1')" align="center"></el-table-column>
            <el-table-column prop="version" :label="$t('version')" :show-overflow-tooltip='true'
                             align="center"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t('loopboard') }}</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <div class="loopRow-tab">
            <div class='el-icon-arrow-left' @click="handleLeft" v-show="title !== 1"></div>
            <div class='el-icon-arrow-left' v-show="title === 1"></div>
            <div class="loopRow-header">{{$t('loopNum')}}{{ title }}</div>
            <div class='el-icon-arrow-right' @click="handleRight" v-show="title < maxBoardNo"></div>
          </div>
          <div class="loopRow-title">
            <div class="loopRow-title_t">{{$t('loopNo')}}</div>
            <div v-for="(item, index) in titleList" :key="index" class="loopNum">{{ item }}</div>
            <div class="loopNum" v-show="maxBoardNo == 0">{{$t('total')}}</div>
            <div class="loopNum numTotal" v-show="maxBoardNo > 0">{{$t('total')}}</div>
          </div>
          <div class="loopList1" :height="offsetWindowHeight">
            <div v-for="(item, index) in loopList" :key="index" class='loopList-box' v-show="index !== 'total'&& index !== 'maxBoardNo'">
                <div class="box-title" :title="index">{{index}}</div>
                <div v-for="(item1, key) in loopList[index]" :key="key" class="loopList-header" v-show="(boardNo1 < key && key <= boardNo)">
                  <span>{{item1}}</span>
                </div>
                <div v-for="(item1, key) in loopList[index]" :key="key + '-'" class="loopList-header sumTotle" v-show="key == 'total'">
                  <span>{{item1}}</span>
                </div>
            </div>
            <div v-for="(item, index) in loopList" :key="index + '-'" class='loopList-box total' v-show="index === 'total' && maxBoardNo > 0">
                <div class="box-title">{{$t('total')}}</div>
                <div v-for="(item1, key) in loopList[index]" :key="key" class="loopList-header" v-show="(boardNo1 < key && key <= boardNo) || key == 'total'">
                  <span>{{item1}}</span>
                </div>
                <div class="loopList-header sumTotle lastBorder" v-show="maxBoardNo > 0">{{loopSum}}</div>
            </div>
            <div class="nodata" v-show="maxBoardNo == 0">
              {{$t('nodata')}}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import Status from "components/Status";
import {
  getArchiveBoard,
  getArchiveConfig,
  getArchiveLoopboard,
  getProductList,
  saveArchive
} from "@/api/manage";
import { debounce } from "@/assets/utils";
export default {
  name: "archive",
  mixins: [BasePage,Status],
  data() {
    return {
      searchForm: {
        projectName: "",
        controllerPsn: ""
      },
      setting: [
        "回路板卡",
        "多线控制盘",
        "总线控制盘",
        "气体灭火器",
        "总线广播盘",
        "事件记录器",
        "图形显示装置",
        "传输设备",
        "GRPS",
        "WIFI",
        "串口调试",
        "接口卡"
      ],
      settingList: "",
      rows: [],
      projectList: [],
      isShow: false,
      titleList: [1, 2, 3, 4, 5, 6, 7, 8],
      boardNo:8,
      boardNo1:0,
      title: 1,
      oldLoop: [],
      output: [],
      sum: 0,
      loading: false,
      loopList:{},
      maxBoardNo:0,
      loopSum:0,
      searching:false,
      quering:false
    };
  },
  mounted() {
    if (this.$store.state.debugFlag) {
      this.searchForm.controllerPsn = this.$store.state.controlInfo.controllerPsn
    }
  },
  methods: {
    querySearchAsync(value, cb) {
      this.isShow = !!value;
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        getProductList(value).then(res => {
          this.loading = false;
          this.projectList = res.data;
          var index = res.data.findIndex(function(item) {
            return item.projectName === value;
          });
          this.searchForm.projectName = value;
          this.searchForm.controllerPsn =
            res.data[index] && res.data[index].psn;
        });
        cb(this.projectList);
      }, 3000 * Math.random());
    },
    getRows(){

    },
    getData(val) {
      // let searchParams = {
      //   controllerPsn: "C980098F982E6B6B"
      // };
       let searchParams = {
        controllerPsn: this.searchForm.controllerPsn
      };
      getArchiveBoard(searchParams).then(res => {
        const boardTypeOptions = this.$store.state.boardTypeOptions;
        res.data.forEach((item) => {
          item.boardType = boardTypeOptions.find(v => v.code === item.boardType).name
        })
        this.rows = res.data;
        this.quering = false
      });
      getArchiveConfig(searchParams).then(res => {
        this.settingList = res.data;
        this.quering = false
      });
      getArchiveLoopboard(searchParams).then(res => {
        if (val) {
        this.success(res.message ? res.message : '操作成功')
        }
        this.quering = false
        const newList = [];
        const deviceTypeOptions = this.$store.state.deviceTypeOptions;
        const language = this.$store.state.language;
        res.data.map(val => {
          deviceTypeOptions.map(item => {
            if (val.devType === item.code) {
              val.devType = language === "chinese" ? item.name : item.nameEn;
            }
          });
          if (val.boardNo === this.title) {
            newList.push(val);
          }
        });
        this.parseData(newList);
        this.oldLoop = res.data;
      });
    },
    parseData(object) {
      var ret = { total: {}, maxBoardNo: 0 };
      //let loopTotal = {};
      for (let i = 0; i < object.length; i++) {
        var item = object[i];
        let row = ret[item.devType + ""];
        if (row == null) {
          row = { total: item.num };
          ret[item.devType + ""] = row;
        } else {
          row["total"] = row["total"] + item.num;
        }

        let boardNo = item.boardNo;
        if (boardNo > ret.maxBoardNo) {
          ret.maxBoardNo = boardNo;
        }
        row[item.loopNo + ""] = item.num;

        if (ret.total[item.loopNo + ""] == null) {
          ret.total[item.loopNo + ""] = item.num;
        } else {
          ret.total[item.loopNo + ""] += item.num;
        }
      }

      let maxloopNo = ret.maxBoardNo * 8;
      for (let loopNo = 1; loopNo <= maxloopNo; loopNo++) {
        for (let key in ret) {
          let row = ret[key];
          if (row[loopNo + ""] == null && key !== 'maxBoardNo') {
            row[loopNo + ""] = 0;
          }
        }
        if (ret.total[loopNo + ""] == null && key !== 'maxBoardNo') {
          ret.total[loopNo + ""] = 0;
        }
      }
      this.loopList = ret
      this.maxBoardNo = ret.maxBoardNo
      let num = 0
      Object.keys(ret).forEach(function(key){
        if (ret[key].total) {
          num = ret[key].total + num
        }
    });
    this.loopSum = num
    },
    //再调试状态下保存数据
    handleSave() {
      this.show()
      let searchParams = {
        controllerPsn: this.searchForm.controllerPsn
      };
      this.searching = true
      saveArchive(searchParams).then(res => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          //this.$message.success(res.message ? res.message : '操作成功')
          this.getData();
        }
        this.searching = false
      }).catch(() => {
        this.failed()
        this.searching = false
      });
    },
    handleRows(){
      this.quering = true
    this.show()
    this.getData(1);
    },
    //输入下拉框
    handleChange(value) {
      debounce(value => {
        getProductList(value).then(res => {
          this.projectList = res.data;
          this.isShow = !!value;
          var index = res.data.findIndex(function(item) {
            return item.projectName === value;
          });
          this.searchForm.projectName = value;
          this.searchForm.controllerPsn =
            res.data[index] && res.data[index].psn;
        });
      }, 200);
    },
    handleSelect(item) {
      this.searchForm.projectName = item.projectName;
      this.searchForm.controllerPsn = item.psn;
      this.isShow = false;
    },
    handleLeft() {
      this.title = this.title - 1;
      this.boardNo = this.boardNo - 8
      this.boardNo1 = this.boardNo1 - 8
      const newList = [];
      const deviceTypeOptions = this.$store.state.deviceTypeOptions;
      const language = this.$store.state.language;
      this.titleList.map(val => {
        newList.push(val - 8);
      });
      this.titleList = newList;
      const newLoop = [];
      this.oldLoop.map(val => {
        deviceTypeOptions.map(item => {
          if (val.devType === item.code) {
            val.devType = language === "chinese" ? item.name : item.nameEn;
          }
        });
        if (val.boardNo === this.title) {
          newLoop.push(val);
        }
      });
      this.loopRows = newLoop;
    },
    handleRight() {
      this.title = this.title + 1;
      this.boardNo = this.boardNo + 8
      this.boardNo1 = this.boardNo1 + 8
      const newList = [];
      this.titleList.map(val => {
        newList.push(val + 8);
      });
      this.titleList = newList;
      const newLoop = [];
      const deviceTypeOptions = this.$store.state.deviceTypeOptions;
      const language = this.$store.state.language;
      this.oldLoop.map(val => {
        deviceTypeOptions.map(item => {
          if (val.devType === item.code) {
            val.devType = language === "chinese" ? item.name : item.nameEn;
          }
        });
        if (val.boardNo === this.title) {
          newLoop.push(val);
        }
      });
      this.loopRows = newLoop;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总价";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += " ";
          } else {
            sums[index] = "N/A";
          }
        });
      }
      return sums;
    }
  }
};
</script>

<style lang="scss" scoped>
.archive {
  width: 100%;
  position: relative;

  .search-drop {
    transform-origin: center top 0px;
    position: absolute;
    top: 50px;
    left: 20px;
    width: 370px;
    border: 1px solid #e4e7ed;
    border-radius: 5px;
    max-height: 280px;
    z-index: 100;
    overflow: auto;
    box-sizing: border-box;
    background-color: #fff;

    .is-loading {
      padding: 0;
      margin: 10px 0;
      li {
        text-align: center;
        height: 100px;
        line-height: 100px;
        font-size: 20px;
        color: #999;
        list-style: none;
      }
    }
    .loaded {
      padding: 0;
      margin: 10px 0;
      li {
        padding: 0 20px;
        margin: 0;
        line-height: 34px;
        cursor: pointer;
        color: #606266;
        font-size: 14px;
        list-style: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .version {
    margin-left: 10px;
  }

  .el-card {
    margin-bottom: 10px;

    .el-card__header {
      span {
        font-size: 16px;
        font-family: Microsoft YaHei, serif !important;
        color: #2f4e68;
        font-weight: bold;
      }

      .clearfix:before,
      .clearfix:after {
        display: table;
        content: "";
      }

      .clearfix:after {
        clear: both;
      }
    }

    .loopRow-tab {
      width: 89%;
      height: 40px;
      line-height: 40px;
      background: #f5f7fa;
      margin: auto;
      border-radius: 4px;
      color: #909399;
      font-weight: 500;
      display: flex;
      justify-content: center;

      .el-icon-arrow-left {
        margin-top: 13px;
      }

      .el-icon-arrow-right {
        margin-top: 13px;
      }

      .loopRow-header {
        margin: 0 10px 0 10px;
      }
    }

    .loopRow-title {
      width: 89%;
      margin:auto;
      display: flex;
      color: #909399;
      font-weight: 500;
      height: 50px;
      line-height: 50px;

      &_t {
        width: 80px;
      }

      .loopNum {
        width: 64px;
        text-align: center;
      }
      .numTotal{
        box-shadow: 0px 2px 0px 0px #f2f5f5;
      }
    }

    .loopRow-box {
      display: flex;
      justify-content: space-around;

      &_body {
        width: 100%;

        .loopRow-body {
          display: flex;
          justify-content: space-around;

          .loopRows-list {
            height: 36px;
            line-height: 36px;
            width: 30px;
          }

          .loopRows-list:first-child {
            width: 92px;
          }
        }
      }
    }

    .loopRow-sum1 {
      width: 5%;

      .loopRow-sum {
        color: #409eff;
        height: 36px;
        line-height: 36px;
      }
    }

    .loopRow-footer {
      display: flex;
      justify-content: space-around;
      color: #409eff;
      height: 50px;
      line-height: 50px;

      &_sum {
        width: 100px;
      }

      .footerNum {
        width: 30px;
      }
    }

    .el-card__body {
      padding: 10px !important;

      .el-form-item {
        margin-bottom: 0px;
      }

      .settingContent {
        .text {
          font-size: 12px;
          font-family: Microsoft YaHei, serif !important;
          color: #646464;
        }

        .item {
          margin-bottom: 8px;
          display: inline-block;
          width: 7.6%;
          text-align: center;
        }
      }
    }
  }
}
.loopList1{
  width: 89%;
  margin:auto;
  max-height: 432px;
  overflow: auto;
  .total{
    color:#409eff;
  }
    .loopList-box{
    display: flex;
    width: 100%;
    height: 50px;
    line-height: 50px;
    .box-title{
      width: 80px;
      text-align: left;
      overflow: hidden;
    }
    .loopList-header{
    width: 64px;
    text-align: center;
    }
    .sumTotle{
      box-shadow: -5px 0px 7px -7px #999a9a;
      box-shadow: -3px 0px 0px 0px #f2f5f5;
      // box-shadow:-10px 0px 0px 0px rgba(0,0,0,0);
      color: #409eff;
      font-weight: 600;
    }
    .lastBorder{
      box-shadow: -3px 1px 0px 0px #f2f5f5;
      margin-top: -1px;
    }
  }
}
.el-card__body {
  padding: 10px !important;
}
.nodata{
    width: 100px;
    margin: auto;
    color: #ccc;
    font-size: 12px;
    margin-top: 10px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 5px; // 纵向滚动条 必写
  border: #000823;
  width: 3px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #409eff;
  height: 10px;
}
</style>
